export default __webpack_public_path__ + "static/media/userPic.4eee5d82.jpg";